import React from "react";
import { Pressable, Text, View, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { fontFamily } from "../../../constants/fonts";
import { colors } from "../../../constants/theme";

/** Map explore: open recap queue. Badge shows count of bites needing a rating. */
function RecapButton({ onPress, pendingCount = 0, style, containerStyle }) {
  const hasPendingRecaps = Number.isFinite(pendingCount) && pendingCount > 0;
  return (
    <View style={[styles.wrap, containerStyle]}>
      <Pressable
        onPress={onPress}
        accessibilityRole="button"
        accessibilityLabel={
          hasPendingRecaps
            ? `Recap, ${pendingCount} bite${pendingCount === 1 ? "" : "s"} need a rating`
            : "Recap"
        }
        style={({ pressed }) => [
          styles.button,
          hasPendingRecaps ? styles.buttonPending : styles.buttonIdle,
          pressed && styles.buttonPressed,
          style,
        ]}
      >
        <Ionicons
          name="camera-outline"
          size={22}
          color={hasPendingRecaps ? colors.brownDark : colors.black}
        />
        <Text
          style={[
            styles.label,
            hasPendingRecaps && styles.labelPending,
          ]}
          numberOfLines={1}
        >
          Recap
        </Text>
      </Pressable>
      {hasPendingRecaps ? (
        <View style={styles.badge} accessibilityElementsHidden>
          <Text style={styles.badgeText}>
            {pendingCount > 99 ? "99+" : String(pendingCount)}
          </Text>
        </View>
      ) : null}
    </View>
  );
}

/** Room above/right of the pill so the count badge is not clipped on Android. */
const BADGE_INSET = 12;

const styles = StyleSheet.create({
  wrap: {
    position: "relative",
    overflow: "visible",
    paddingTop: BADGE_INSET,
    paddingRight: BADGE_INSET,
  },
  button: {
    height: 44,
    borderRadius: 9999,
    paddingHorizontal: 14,
    borderWidth: 2,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonIdle: {
    borderColor: colors.borderLight,
    backgroundColor: colors.white,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.22,
    shadowRadius: 4,
    elevation: 4,
  },
  /** Draws the eye when there are unrated bites */
  buttonPending: {
    borderColor: colors.brownDark,
    backgroundColor: "#FFF9F4",
    shadowColor: colors.brownDeep,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.35,
    shadowRadius: 8,
    elevation: 8,
  },
  buttonPressed: {
    opacity: 0.92,
    transform: [{ scale: 0.98 }],
  },
  label: {
    marginLeft: 6,
    fontFamily: fontFamily.abhayaBold,
    color: colors.black,
    fontSize: 15,
    lineHeight: 20,
    includeFontPadding: false,
  },
  labelPending: {
    color: colors.brownDark,
  },
  badge: {
    position: "absolute",
    top: 0,
    right: 0,
    minWidth: 24,
    height: 24,
    borderRadius: 12,
    paddingHorizontal: 7,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#DC2626",
    borderWidth: 2.5,
    borderColor: colors.white,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.35,
    shadowRadius: 3,
    elevation: 6,
  },
  badgeText: {
    fontSize: 12,
    lineHeight: 14,
    color: colors.white,
    fontFamily: fontFamily.abhayaBold,
    includeFontPadding: false,
    fontVariant: ["tabular-nums"],
  },
});

export default RecapButton;
